export const screenSizes = {
    smallPhone: 320,
    phone: 564,
    tablet: 768,
    desktop: 992,
    maxDesktop: 1920,
}
